import { useRoute } from '#imports'
import { hometogoCookie } from './hometogoCookie'
import { extractHomeToGoLocationData } from './extractHomeToGoLocationName'
import type { HomeToGoLocationData } from '../entities/types'
import type { schemaType as CottageListData } from '~~/shared/api/rurality/v3/search/cottages/schema'

const buildHometogoUrl = (locationData: HomeToGoLocationData): string => {
  const route = useRoute()
  const baseUrl = 'https://www.hometogo.es/affiliate/search/escapadaRural'
  const url = new URL(baseUrl)

  url.searchParams.set('product_type', 'compare')

  if (locationData.name) {
    url.searchParams.set('q', locationData.name)
  }

  if (locationData.coordinates) {
    const lat = locationData.coordinates.lat.toFixed(12)
    const lng = locationData.coordinates.lng.toFixed(12)
    const coordString = `${lat};${lng}`
    url.searchParams.set('c', coordString)
  } else {
    url.searchParams.set('c', ';')
  }

  const params = route.query

  if (params.d && params.do) {
    const dateIn = params.d as string
    const dateOut = params.do as string
    const arrival = normalizeDate(dateIn)
    const nights = calculateNights(dateIn, dateOut)

    url.searchParams.set('arrival', arrival)
    url.searchParams.set('duration', nights.toString())
  }

  if (params.c) {
    const capacity = parseInt(params.c as string, 10)
    if (capacity > 0) {
      url.searchParams.set('persons', capacity.toString())
    }
  }

  return url.toString()
}

const normalizeDate = (date: string): string => {
  return date
}

const calculateNights = (dateIn: string, dateOut: string): number => {
  const checkIn = parseDate(dateIn)
  const checkOut = parseDate(dateOut)
  const diffTime = Math.abs(checkOut.getTime() - checkIn.getTime())
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
}

const parseDate = (dateString: string): Date => {
  const parts = dateString.split('-')
  if (parts.length === 3) {
    const day = parseInt(parts[0], 10)
    const month = parseInt(parts[1], 10) - 1
    const year = parseInt(parts[2], 10)
    return new Date(year, month, day)
  }
  return new Date(dateString)
}

export const hometogoPopunderNavigation = (
  targetUrl: string,
  cottagesData?: CottageListData,
): void => {
  const { setHomeToGoCookie } = hometogoCookie()

  if (import.meta.server) return

  setHomeToGoCookie()

  const locationData = extractHomeToGoLocationData(cottagesData)
  const hometogoUrl = buildHometogoUrl(locationData)

  if (targetUrl) {
    const newWindow = window.open(targetUrl, '_blank')
    if (newWindow) {
      newWindow.focus()
    }
  }

  window.location.href = hometogoUrl
}
